// extracted by mini-css-extract-plugin
export default {"spinner":"ZPqp7zxCJ8CGIkt4Fu_e"};